import React from 'react';
import ChangeSubCategoryPosition from './components/ChangeSubCategoryPosition/ChangeSubCategoryPosition';
import ChangeSubCategoryPositionState from './changeSubCategoryPositionState/ChangeSubCategoryPositionState';

const ChangeSubCategoryPositionPage: React.FC = () => {
	return (
		<ChangeSubCategoryPositionState>
			<ChangeSubCategoryPosition />
		</ChangeSubCategoryPositionState>
	);
};

export default ChangeSubCategoryPositionPage;
